import { render } from "./MaterialInput.vue?vue&type=template&id=9068393a"
import script from "./MaterialInput.vue?vue&type=script&lang=js"
export * from "./MaterialInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__